module.exports = __webpack_public_path__ + "img/indicator.9a09f9c7.svg";